import { IngestionMethod } from '@lib/company-content-relations';
import { withStyles, Theme, Chip, Tooltip } from '@material-ui/core';
import React from 'react';
import { indigo, pink, yellow, red, blue } from '@material-ui/core/colors';
import { generateChipColor } from '@lib/common';
import { GiArtificialHive, SiMicrosoftexcel, MdKeyboard, TiNews } from '@icon/react-icons';

type IngestionMethodChipIconProps = React.ComponentProps<typeof Chip> & {
  type: IngestionMethod | `${IngestionMethod}`;
  iconOnly?: boolean;
};

const ingestionMethodMap = {
  [IngestionMethod.XLS]: {
    color: pink,
    label: 'XLS',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
  [IngestionMethod.CSV]: {
    color: pink,
    label: 'CSV',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
  [IngestionMethod.DELI]: {
    color: yellow,
    label: 'Deli',
    icon: <MdKeyboard style={{ color: 'inherit' }} />,
  },
  [IngestionMethod.SelfService]: {
    color: red,
    label: 'Self Service',
    icon: <GiArtificialHive />,
  },
  [IngestionMethod.Backend]: {
    color: indigo,
    label: 'Backend',
    icon: <TiNews />,
  },
  unknown: {
    color: pink,
    label: 'unknown',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
};

export const IngestionMethodChip = withStyles<string, {}, IngestionMethodChipIconProps>(
  (theme: Theme) => ({
    root: ({ type }) =>
      generateChipColor(theme, (ingestionMethodMap[type] || ingestionMethodMap.unknown).color),
    label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  })
)(({ type, children, iconOnly, ...props }: IngestionMethodChipIconProps) => {
  const map = ingestionMethodMap[type] || ingestionMethodMap.unknown;
  return (
    <Tooltip title={`Ingestion Method:  ${type}`}>
      {map.label != 'unknown' ? (
        <Chip color="secondary" icon={map.icon} label={iconOnly ? null : map.label} {...props} />
      ) : (
        <Chip color="secondary" label={iconOnly ? null : type} {...props} />
      )}
    </Tooltip>
  );
});
